(function () {
  const revealEls = document.querySelectorAll(".mileyo-reveal");

  if (revealEls.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add("is-visible");
          }, index * 70);
        }
      });
    }, { threshold: 0.14 });

    revealEls.forEach(el => observer.observe(el));
  }

  const faqItems = document.querySelectorAll(".mileyo-faq-item");

  faqItems.forEach(item => {
    const btn = item.querySelector(".mileyo-faq-q");
    if (!btn) return;

    btn.addEventListener("click", () => {
      faqItems.forEach(other => {
        if (other !== item) other.classList.remove("active");
      });
      item.classList.toggle("active");
    });
  });

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener("click", function(e) {
      const selector = this.getAttribute("href");
      if (!selector || selector === "#") return;

      const target = document.querySelector(selector);
      if (!target) return;

      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });
})();

(function () {
  function setMileyoAnnouncementHeight() {
    const announcementBar =
      document.querySelector('.announcement-bar-section') ||
      document.querySelector('.announcement-bar') ||
      document.querySelector('[id*="Announcement"]') ||
      document.querySelector('[id*="announcement"]') ||
      document.querySelector('[class*="announcement"]');

    const height = announcementBar && announcementBar.offsetHeight
      ? announcementBar.offsetHeight
      : 0;

    document.documentElement.style.setProperty(
      '--mileyo-announcement-height',
      height + 'px'
    );
  }

  setMileyoAnnouncementHeight();

  window.addEventListener('load', setMileyoAnnouncementHeight);
  window.addEventListener('resize', setMileyoAnnouncementHeight);
  document.addEventListener('shopify:section:load', setMileyoAnnouncementHeight);
  document.addEventListener('shopify:section:unload', setMileyoAnnouncementHeight);
  document.addEventListener('shopify:section:select', setMileyoAnnouncementHeight);
})();

(function () {
  function updateMileyoHeader() {
    const header = document.querySelector('.mileyo-header');
    if (!header) return;

    if (window.scrollY > 80) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }

  updateMileyoHeader();

  window.addEventListener('scroll', updateMileyoHeader, { passive: true });
  window.addEventListener('load', updateMileyoHeader);
})();
(function () {
  const header = document.querySelector('[data-mileyo-header]');
  const burger = document.querySelector('[data-mileyo-burger]');
  const mobileMenu = document.querySelector('[data-mileyo-mobile-menu]');
  const closeBtn = document.querySelector('[data-mileyo-menu-close]');

  if (!header || !burger || !mobileMenu) return;

  function updateHeaderOnScroll() {
    if (window.scrollY > 20 || header.classList.contains('mileyo-header--solid')) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }

  updateHeaderOnScroll();
  window.addEventListener('scroll', updateHeaderOnScroll);

  function openMenu() {
    mobileMenu.classList.add('is-open');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileMenu.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  burger.addEventListener('click', function () {
    if (mobileMenu.classList.contains('is-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closeMenu);
  }

  mobileMenu.addEventListener('click', function (event) {
    if (event.target === mobileMenu) {
      closeMenu();
    }
  });

  mobileMenu.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 980) {
      closeMenu();
    }
  });
})();

(function () {
  function openModal(modalId) {
    const modal = document.getElementById(modalId);
    if (!modal) return;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mileyo-modal-open');

    const closeButton = modal.querySelector('[data-mileyo-product-modal-close]');
    if (closeButton) closeButton.focus();
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    const openedModals = document.querySelectorAll('.mileyo-product-modal.is-open');
    if (!openedModals.length) {
      document.body.classList.remove('mileyo-modal-open');
    }
  }

  document.addEventListener('click', function (event) {
    const openButton = event.target.closest('[data-mileyo-product-modal-open]');
    if (openButton) {
      event.preventDefault();

      const modalId = openButton.getAttribute('data-mileyo-product-modal-open');
      openModal(modalId);
      return;
    }

    const closeButton = event.target.closest('[data-mileyo-product-modal-close]');
    if (closeButton) {
      const modal = closeButton.closest('.mileyo-product-modal');
      closeModal(modal);
    }
  });
  

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('.mileyo-product-modal.is-open').forEach(function (modal) {
      closeModal(modal);
    });
  });
}

)();

(function () {
  document.addEventListener('click', function (event) {
    const button = event.target.closest('.mileyo-description-toggle');
    if (!button) return;

    const description = button.previousElementSibling;
    if (!description) return;

    description.classList.toggle('is-open');

    button.textContent = description.classList.contains('is-open')
      ? 'Voir moins'
      : 'Voir plus';
  });
})();